import styled from 'styled-components'

import { ContentPadded } from './ContentPadded'

export const ContentScroll = styled(ContentPadded)`
	padding-bottom: 36px;
`
